import {
  Box,
  Divider,
  Flex,
  Text,
  Menu,
  MenuButton,
  MenuItem,
  MenuList
} from '@chakra-ui/react';
import { faCaretDown } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonText } from '@morressier/alembic';
import { useState } from 'react';

interface IVendorExportCountBoxProps {
  label: 'total' | 'success' | 'failed' | 'inProgress';
  count: number;
  onStatusClick?: (status: 'success' | 'failed' | 'inProgress') => void;
  onTodayClick?: (label: 'today' | 'total') => void;
  countLabel?: string;
  setCountLabel?: (arg0: string) => void;
}

const VendorExportCountBox = ({
  label,
  count,
  onStatusClick,
  onTodayClick,
  countLabel,
  setCountLabel
}: IVendorExportCountBoxProps) => {
  const labelMap: Record<string, string> = {
    total: 'Total Exports',
    success: 'Success',
    failed: 'Failed',
    inProgress: 'In Progress'
  };
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleTodayClick = () => {
    setCountLabel && setCountLabel(`Today's Exports`);
    setIsMenuOpen(false);
    onTodayClick?.('today');
  };

  const handleTotalClick = () => {
    setCountLabel && setCountLabel(`Total Exports`);
    setIsMenuOpen(false);
    onTodayClick?.('total');
  };

  return (
    <Box borderWidth="1px" p={3} bg="white" width="100%" position="relative">
      {label !== 'total' ? (
        <Flex justifyContent="space-between">
          <Text casing="capitalize">{labelMap[label]}</Text>
          <ButtonText
            cursor="pointer"
            onClick={() =>
              onStatusClick?.(label as 'success' | 'failed' | 'inProgress')
            }
          >
            View
          </ButtonText>
        </Flex>
      ) : (
        <Flex justifyContent="space-between" alignItems="center">
          <Menu isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)}>
            <MenuButton
              as={ButtonText}
              cursor="pointer"
              onClick={() => setIsMenuOpen(prev => !prev)}
            >
              {countLabel}
            </MenuButton>
            <MenuList
              position="absolute"
              top="100%"
              left={0}
              mt={1}
              zIndex={10}
              width={'100%'}
              borderWidth="1px"
              bg="white"
            >
              <MenuItem onClick={handleTotalClick}>Total exports</MenuItem>
              <MenuItem onClick={handleTodayClick}>Today’s exports</MenuItem>
            </MenuList>
          </Menu>

          <FontAwesomeIcon
            icon={faCaretDown}
            style={{ cursor: 'pointer' }}
            onClick={() => setIsMenuOpen(prev => !prev)}
          />
        </Flex>
      )}

      <Divider borderWidth="1px" />
      <Text fontWeight="bold">{count}</Text>
    </Box>
  );
};

export default VendorExportCountBox;
